import CollapsableTable from 'components/collapsable-table';
import type React from 'react';
import EmptyState from '@features/regional-overview/digital-traps/components/empty-state';
import { FLIGHT_PREDICTIONS_TAB } from '@features/regional-overview/digital-traps/domain/tests-id.constants';
import { EmptyStateWrapper } from '../../trap-management-tabs.style';
import styles from './daily-counts.module.css';
import { DailyCountsPredictionsCardList } from './daily-counts-predictions-card-list';
import { useFlightPredictionsData } from './flight-predictions-data.hook';

export const FlightPredictionsTab = () => {
  const { networks } = useFlightPredictionsData();

  if (!Array.isArray(networks) || networks.length === 0) {
    return (
      <EmptyStateWrapper>
        <EmptyState context='search' />
      </EmptyStateWrapper>
    );
  }

  return (
    <>
      <div className={styles.predictionsWeb}>
        <CollapsableTable
          dataTestId={FLIGHT_PREDICTIONS_TAB}
          items={networks as unknown as React.ComponentProps<typeof CollapsableTable>['items']}
        />
      </div>
      <div className={styles.predictionsMobile}>
        <DailyCountsPredictionsCardList networks={networks} />
      </div>
    </>
  );
};
